import { Divider, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import ManageAnswer from "./components/ManageAnswer";
import AnswerDetailActivity from "./components/AnswerDetailActivity";
import CommentSection from "./components/CommentSection";
import React from "react";
import { useRightSidebar } from "../../../context/RightSidebarContext";

/**
 * Right-side panel for managing an answer: Manage / Activity / Comments
 * @param {?Object} questionData - Question data Can be null while loading
 */
const AnswerDetailManagement = ({ questionData, applyActivity, canSave, hideStatuses, hideRelevance, extraDetails }) => {
  let questionId = questionData?.id;

  return (
    <Tabs
      variant="primary"
      mb={6}
      defaultIndex={0}
      isLazy={true}
      // onChange={handleTabChange}
    >
      <TabList
        position="sticky"
        top="0"
        bg="gray.50" // Ensure background is solid so content doesn't overlap
        zIndex="10"
      >
        <Tab>Manage</Tab>
        <Tab>Activity</Tab>
        <Tab>Comments</Tab>
      </TabList>
      <Divider />
      <TabPanels>
        <TabPanel>
          <ManageAnswer
            questionData={questionData}
            canSave={canSave}
            hideStatuses={hideStatuses}
            hideRelevance={hideRelevance}
            extraDetails={extraDetails}
          />
        </TabPanel>
        <TabPanel p={0}>
          <AnswerDetailActivity questionData={questionData} applyActivity={applyActivity} canSave={canSave} />
        </TabPanel>
        <TabPanel>
          <CommentSection targetId={questionId} targetTable="issb_question" />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default AnswerDetailManagement;
